<template>
    <div class="container">
        <div @click="goback" style="font-size:14px;margin-bottom:10px;cursor: pointer;width:50px">
            <i class="el-icon-back"></i>
            返回
        </div>
        <div class="item"><b>批次token：</b><el-tag type="primary" size="small">{{ token }}</el-tag></div>
        <div class="item"><b>批次总数：</b><el-tag type="primary" size="small">{{ total }}</el-tag></div>
        <div class="item">
            <b>红外报告：</b>已检测 <el-tag type="success" size="small">{{ ircut.check }}</el-tag> 未检测 <el-tag type="danger"
                size="small">{{
                    ircut.not_check }}</el-tag>
        </div>
        <div class="item">
            <b>云台报告：</b>已检测 <el-tag type="success" size="small">{{ ptz.check }}</el-tag> 未检测 <el-tag type="danger"
                size="small">{{
                    ptz.not_check }}</el-tag>
        </div>
        <div class="item">
            <b>按键报告：</b>已检测 <el-tag type="success" size="small">{{ key.check }}</el-tag> 未检测 <el-tag type="danger"
                size="small">{{
                    key.not_check }}</el-tag>
        </div>
        <div class="item">
            <b>wifi强度报告：</b>已检测 <el-tag type="success" size="small">{{
                wifi.check
            }}</el-tag> 未检测 <el-tag type="danger" size="small">{{ wifi.not_check }}</el-tag>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
import api from '../../axios/productionManage'
import util from '../../util/util'
export default {
    name: '',
    props: {},
    setup() {
        return {
        }
    },
    mixins: [],
    components: {},
    data() {
        return {
            token: "",
            total: 0,
            ircut: {
                check: 0,
                not_check: 0
            },
            ptz: {
                check: 0,
                not_check: 0
            },
            key: {
                check: 0,
                not_check: 0
            },
            wifi: {
                check: 0,
                not_check: 0
            }

        }
    },
    computed: {},
    watch: {},
    methods: {
        GetReport() {
            api.DeviceTrackReport({
                data: {
                    token: this.token,
                },
                region: 'gb',
                payload_version: 'v1.0'
            }).then(res => {
                if (res.data.code == 200) {
                    const { ircut, key, ptz, wifi, total } = res.data.data
                    this.ircut = ircut
                    this.key = key
                    this.ptz = ptz
                    this.wifi = wifi
                    this.total = total
                    return
                }
                this.$message.error('获取失败' + res.data.msg)
            })
        },
        goback() {
            this.$router.push('/product/productionapply')
        }
    },
    filters: {},
    mounted() {
        this.token = this.$route.params.code.split('&')[0]
        this.GetReport()
    },
    created() {
    }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.item {
    padding: 10px 0px;
}
</style>
